var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#292929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H22M14 16H26M24.6667 16L24.1991 23.0129C24.129 24.065 24.0939 24.5911 23.8667 24.99C23.6666 25.3412 23.3648 25.6235 23.0011 25.7998C22.588 26 22.0607 26 21.0062 26H18.9938C17.9393 26 17.412 26 16.9989 25.7998C16.6352 25.6235 16.3334 25.3412 16.1333 24.99C15.9061 24.5911 15.871 24.065 15.8009 23.0129L15.3333 16M18.6667 19V22.3333M21.3333 19V22.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.50bdcf5aa0f6b67b5999cd2c028df8cb.svg";
export { ForwardRef as ReactComponent };